<template>
  <div :id="data.id" class="relative mb-10 md:mb-14">
    <div
      v-if="data.items && data.items.length"
      v-lazy-background="getAssetUrl(data.backgroundImage)"
      class="text-white"
    >
      <div
        v-for="(item, i) in data.items"
        :key="i"
        class="relative flex items-center sm:min-h-[400px] md:min-h-[460px] xl:min-h-[520px] 3xl:min-h-[696px]"
      >
        <div class="container flex flex-col sm:flex-row">
          <div
            class="sm:item-center relative z-10 order-last max-w-full pb-6 pt-8 sm:flex sm:w-1/2 sm:justify-center sm:py-20 xl:w-[680px] 3xl:w-[920px]"
            :class="i % 2 === 0 ? 'sm:mr-auto' : 'sm:ml-auto'"
          >
            <div
              class="w-full sm:w-[80%] md:w-[65%] xl:w-[440px] 3xl:w-[600px]"
            >
              <UiSectionTitle
                v-if="item.title"
                :title="item.title"
                tag="h3"
                class="title mb-4 text-xl uppercase leading-none md:text-3xl xl:mb-6 xl:text-5xl"
              />

              <div
                v-if="item.text"
                class="text-md leading-[1.8rem]"
                v-html="item.text"
              />
            </div>
          </div>

          <div
            v-if="item.image || item.video"
            class="-mx-6 aspect-[380/280] sm:absolute sm:m-0 sm:h-full sm:w-1/2 xl:aspect-[712/520] 3xl:aspect-[952/696]"
            :class="i % 2 === 0 ? 'right-0 top-0' : 'bottom-0 left-0'"
          >
            <CdnImg
              v-if="item.image"
              :src="handleImageSrc(item.image)"
              :alt="handleImageAlt(item.image)"
              loading="lazy"
              class="inset-0 h-full w-full object-contain"
              :class="
                i % 2 === 0 ? 'sm:objet-right-top' : 'sm:object-left-bottom'
              "
              :width="952"
              :height="696"
            />
            <UiVideo
              v-else-if="item.video"
              :src="item.video"
              muted
              loop
              autoplay
              container-size
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useMediaAsset } from '~/composables';
import { CdnImg } from '@webplatform/cdn-image';
import { handleImageSrc, handleImageAlt } from '~/helpers';

interface Props {
  data?: any;
}

withDefaults(defineProps<Props>(), {
  data: () => ({}),
});

const { getAssetUrl } = useMediaAsset();
</script>
